export default {
  'CHANGE_INVOICE' (state, payload) {
    state.items = [...state.items, ...JSON.parse(JSON.stringify(payload))]
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/invoices/mutations.js